/*eslint-disable*/
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { Box, IconButton, Input, List, ListItem, Paper, Popper, Tooltip } from "@mui/material";
import { useState } from "react";

const searchableFields = [
    "propertyId", "web_Ref_No", "lightstoneId", "address.description", "erfNumber", "sectionNumber",
    "suburb", "area", "listingAgent", "ownerDetails", "ListingId", "ListingPPId", "email"
];

const fieldTooltip = `
Search Across: Property ID, Web Ref, Street Address, Erf Number,
Suburb, Area, Listing Agents, Owner Details, P24 Listing #, PP Listing #
`;

const getNestedValue = (obj, path) =>
    path.split('.').reduce((acc, key) => acc?.[key] ?? "", obj);

const SearchWithSuggestions = ({ currentListings = [], setFilteredListings }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [input, setInput] = useState("");
    const [suggestions, setSuggestions] = useState([]);

    const performSearch = (valueToSearch) => {
        const value = valueToSearch.toLowerCase();

        if (!value.trim()) {
            setSuggestions([]);
            setFilteredListings([]);
            return;
        }

        const matchedListings = currentListings.filter((listing) =>
            searchableFields.some((field) => {
                const fieldValue = getNestedValue(listing, field);

                // If it's a string → case-insensitive search
                if (typeof fieldValue === "string") {
                    return fieldValue.toLowerCase().includes(String(value).toLowerCase());
                }

                // If it's a number → numeric equality check
                if (typeof fieldValue === "number") {
                    return fieldValue === Number(value);
                }

                // fallback: no match
                return false;
            })
        );


        setFilteredListings(matchedListings);
        const uniqueMatches = Array.from(
            new Set(
                matchedListings
                    .flatMap((listing) =>
                        searchableFields.map((field) => {
                            const fieldValue = getNestedValue(listing, field);

                            if (typeof fieldValue === "string") {
                                return fieldValue.toLowerCase();
                            }

                            if (typeof fieldValue === "number") {
                                return String(fieldValue); // keep numbers searchable
                            }

                            return ""; // ignore null/undefined/objects
                        })
                    )
                    .filter((val) => {
                        if (!val) return false;

                        // if value is numeric and val is numeric → match numerically
                        if (!isNaN(Number(value)) && !isNaN(Number(val))) {
                            return Number(val) === Number(value);
                        }

                        // otherwise → case-insensitive substring
                        return val.toLowerCase().includes(String(value).toLowerCase());
                    })
            )
        ).slice(0, 10); // Limit suggestions

        setSuggestions(uniqueMatches);



    };

    const handleSearch = (e) => {
        const value = e.target.value;
        setInput(value);
        performSearch(value);
    };

    const handleSuggestionClick = (suggestion) => {
        setInput(suggestion);
        performSearch(suggestion);
        setAnchorEl(null); // Close the suggestions popper
    };

    return (
        <Box sx={{ position: "relative", width: 500 }}>
            <Tooltip title={fieldTooltip} arrow placement="top">
                <Box sx={{ display: "flex", alignItems: "center", width: "100%", position: "relative" }}>
                    <Input
                        fullWidth
                        placeholder="Search by Keyword"
                        value={input}
                        onChange={handleSearch}
                        onFocus={(e) => setAnchorEl(e.currentTarget)}
                        onBlur={() => setTimeout(() => setAnchorEl(null), 200)} // Delay to allow clicking
                        sx={{
                            borderWidth: 2,
                            borderStyle: "solid",
                            borderColor: "#002147", // dark blue
                            height: 54,
                            backgroundColor: "white",
                            fontSize: 16,
                            borderRadius: 0, // square
                            color: "grey",
                            paddingRight: 3,
                            px: 2,
                        }}
                    />
                    <IconButton
                        size="small"
                        onClick={() => {
                            if (input) {
                                setInput("");
                                setSuggestions([]);
                                setFilteredListings([]);
                            }
                        }}
                        disabled={!input}
                        sx={{ position: "absolute", right: 48, zIndex: 2 }}
                    >
                        <CloseIcon fontSize="small" sx={{ color: (theme) => theme.palette.primary.main }} />
                    </IconButton>
                    <IconButton
                        size="small"
                        onClick={() => performSearch(input)}
                        sx={{ position: "absolute", right: 8 }}
                    >
                        <SearchIcon sx={{ color: (theme) => theme.palette.primary.main }} />
                    </IconButton>
                </Box>
            </Tooltip>

            <Popper open={!!anchorEl && suggestions.length > 0} anchorEl={anchorEl} placement="bottom-start" style={{ zIndex: 1500 }}>
                <Paper sx={{ mt: 1, p: 1, minWidth: 250 }}>
                    <List dense>
                        {suggestions.map((item, index) => (
                            <ListItem
                                key={index}
                                onClick={() => handleSuggestionClick(item)}
                                sx={{ cursor: "pointer", fontSize: "0.9rem", '&:hover': { backgroundColor: '#f0f0f0' } }}
                            >
                                {item}
                            </ListItem>
                        ))}
                    </List>
                </Paper>
            </Popper>
        </Box>
    );
};

export default SearchWithSuggestions;